export const CustomerValidEntityTypes = [
    "Private Ltd",
    "Public Ltd",
    "LLP",
    "Partnership",
];

export const CustomerValidDesignations = [
    'Founder',
    'CEO',
    'Director',
    'CFO',
    'Authorised Signatory',
    'Accounts Department',
    'Finance Department',
    'Other',
    'Manager',
    'Consultant',
];

export const AddressType = ['Registered', 'Corporate', 'Branch', 'Billing']